import React, { useState } from 'react'
import StoretitleCloudkitchen from '../../../composed/storetitle/storetitleCloudkitchen'
import { fontFamily, letterSpacing } from '@mui/system';

const CloudKitchenMenuMobile = () => {
    const [selected, setSelected] = useState("brunch");

    const buttonStyle = (isSelected) => ({
        padding: "10px 20px",
        border: isSelected ? "1px solid #ccc" : 'none',
        borderRadius: isSelected ? "5px" : "0px 5px 5px 0px",
        cursor: "pointer",
        backgroundColor: isSelected ? "#342870" : "#f0f0f0",
        fontFamily: isSelected ? 'Inter Bold' : 'Inter Regular',
        color: isSelected ? "#fff" : "gray",
        letterSpacing: '0.5px',
        transition: "background-color 0.2s ease",
        width: '100%',
        height: '40px'
    });
    return (
        <div>
            <StoretitleCloudkitchen />

            <div style={{ display: 'flex', flexDirection: 'row', backgroundColor: '#f0f0f0', padding: '8px' }}>
                <button
                    style={buttonStyle(selected === "brunch")}
                    onClick={() => setSelected("brunch")}
                >
                    Brunch
                </button>
                <button
                    style={buttonStyle(selected === "dinner")}
                    onClick={() => setSelected("dinner")}
                >
                    Dinner
                </button>
            </div>

        </div >
    )
}

export default CloudKitchenMenuMobile